import { useEffect } from 'react';

const SITE = 'https://menloparkflorist.store';
const DEFAULT_IMAGE = 'https://images.unsplash.com/photo-1487530811176-3780de880c2d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&h=630&fit=crop';

function setNameMeta(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setPropMeta(prop, content) {
  if (!content) return;
  let el = document.querySelector(`meta[property="${prop}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', prop);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setCanonical(href) {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

function setJsonLd(id, data) {
  let el = document.getElementById(id);
  if (!data) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement('script');
    el.type = 'application/ld+json';
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

// Lightweight per-route SEO manager (no external deps)
export default function Seo({ title, description, path = '/', image, jsonLd, type = 'website', publishedTime }) {
  useEffect(() => {
    const url = `${SITE}${path}`;
    const img = image || DEFAULT_IMAGE;
    if (title) document.title = title;
    setNameMeta('description', description);
    setPropMeta('og:type', type);
    setPropMeta('og:title', title);
    setPropMeta('og:description', description);
    setPropMeta('og:url', url);
    setPropMeta('og:image', img);
    if (publishedTime) setPropMeta('article:published_time', publishedTime);
    setNameMeta('twitter:title', title);
    setNameMeta('twitter:description', description);
    setNameMeta('twitter:image', img);
    setCanonical(url);
    setJsonLd('route-jsonld', jsonLd);
    return () => setJsonLd('route-jsonld', null);
  }, [title, description, path, image, jsonLd, type, publishedTime]);

  return null;
}

export { SITE };
